import(/* webpackMode: "eager" */ "/vercel/path0/app/game/page.js");
